import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "notification-message" }
const _hoisted_2 = { class: "notification-message__content" }
const _hoisted_3 = {
  key: 0,
  class: "notification-message__inner-icon"
}
const _hoisted_4 = { class: "notification-message__content-detail" }
const _hoisted_5 = { class: "notification-message__container-text" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 0,
  class: "notification-message__subtitle"
}
const _hoisted_8 = {
  key: 0,
  class: "notification-message__content-container-button"
}

import { PropType, onMounted, onUnmounted, ref } from "vue";
import { TirPmNotificationModel } from "./models";
import { TirPmButton, TirPmButtonVariantEnum, TirPmButtonSizeEnum } from "tir-pm-button";
import { TirPmStatusBudge } from "tir-pm-status-budge";
import { XMarkIcon } from "tir-style-system/icons/solid";

// import {
//   ExclamationCircleIcon,
//   InformationCircleIcon,
//   CheckCircleIcon,
//   XCircleIcon,
// } from "./icon";
// import { XMarkIcon } from "@heroicons/vue/24/outline";

/**Параметры компонента */

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmNotificationMessage',
  props: {
  message: { type: Object as PropType<TirPmNotificationModel>, default: null },
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props;


/**События компонента */


/**Таймер на закрытие компонента */
const closeTimeout = ref<any>(null);

/**После рендера компонента */
onMounted(() => {
  if (props.message.life)
    closeTimeout.value = setTimeout(
      () => close({ message: props.message, type: "life-end" }),
      props.message.life,
    );
});
/**После удаления компонента */
onUnmounted(() => clearCloseTimeout());

/**Отправка события о закрытии компонента */
const close = (params: any) => emit("close", params);
/**Очистка таймера на закрытие сообщения */
const clearCloseTimeout = () => {
  if (!closeTimeout.value) return;
  clearTimeout(closeTimeout.value);
  closeTimeout.value = null;
};
/**Клик по кнопке закрытия сообщения */
const onCloseClick = () => {
  clearCloseTimeout();
  close({ message: props.message, type: "close" });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.message.type)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (props.message.type == 'info')
              ? (_openBlock(), _createBlock(_unref(TirPmStatusBudge), {
                  key: 0,
                  "status-color": "info-invert",
                  "status-icon-type": "info"
                }))
              : _createCommentVNode("", true),
            (props.message.type == 'success')
              ? (_openBlock(), _createBlock(_unref(TirPmStatusBudge), {
                  key: 1,
                  "status-color": "positive-invert",
                  "status-icon-type": "positive"
                }))
              : _createCommentVNode("", true),
            (props.message.type == 'warn')
              ? (_openBlock(), _createBlock(_unref(TirPmStatusBudge), {
                  key: 2,
                  "status-color": "alert-invert",
                  "status-icon-type": "alert"
                }))
              : _createCommentVNode("", true),
            (props.message.type == 'error')
              ? (_openBlock(), _createBlock(_unref(TirPmStatusBudge), {
                  key: 3,
                  "status-color": "negative-invert",
                  "status-icon-type": "negative"
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            innerHTML: __props.message.title,
            class: "notification-message__title"
          }, null, 8, _hoisted_6),
          (__props.message.subtitle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(__props.message.subtitle), 1))
            : _createCommentVNode("", true)
        ]),
        (props.message.labelButton)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_unref(TirPmButton), {
                variant: _unref(TirPmButtonVariantEnum).LinkInvertState,
                size: _unref(TirPmButtonSizeEnum).Small,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (props.message.callbackButton()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.message.labelButton), 1)
                ]),
                _: 1
              }, 8, ["variant", "size"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (__props.message.closable)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "notification-message__close",
          onClick: onCloseClick
        }, [
          _createVNode(_unref(XMarkIcon))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})